// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1566) return "static/chunks/1566-00c4bb74bc72bfb3.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"408":"ac3ac4796d2fb356","876":"bcb7288bdf30e67f","5319":"0ab5094db664ec71","6069":"2a4fb232cc761d0d","7139":"c431077662806cb0"}[chunkId] + ".js";
};